import { render } from "./Sale_Transfers.vue?vue&type=template&id=0dacbd04"
import script from "./Sale_Transfers.vue?vue&type=script&lang=js"
export * from "./Sale_Transfers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__